import { createUseAuthStore } from '@pro4-erp/core-web';
import { User } from '../user/user';

export const useAuthStore = createUseAuthStore<User>();
